import { z } from 'zod'

const PRODUCT_MANAGEMENT_TAB_VALUES = [
  'map',
  'kanban',
  'steering',
  'summaries',
  'support-tickets',
] as const
export type ProductManagementTabValue = (typeof PRODUCT_MANAGEMENT_TAB_VALUES)[number]

/** Onglet actif porté par l'URL : il survit au rafraîchissement et au partage de lien. */
export const productManagementSearchSchema = z.object({
  tab: z.enum(PRODUCT_MANAGEMENT_TAB_VALUES).catch('map'),
})
